import { Plane, Briefcase, MapPin, Users } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const JOURNEYS = [
  {
    icon: Plane,
    title: "Airport Transfers",
    body: "Start and end your journey comfortably.",
  },
  {
    icon: Briefcase,
    title: "Corporate Travel",
    body: "Professional transportation for teams and business travel.",
  },
  {
    icon: MapPin,
    title: "Intercity Travel",
    body: "Long-distance journeys with comfort and reliability.",
  },
  {
    icon: Users,
    title: "Events & Group Travel",
    body: "Reliable premium transportation for events and larger groups.",
  },
];

export const JourneyTypes = () => (
  <section
    id="journeys"
    data-testid="journey-types"
    className="bg-ivory text-dark py-16 sm:py-24 lg:py-[132px]"
  >
    <div className="container-bettr">
      <div className="flex flex-col items-center text-center mb-16 lg:mb-20">
        <Reveal>
          <Eyebrow chapter="03" className="justify-center">
            Built For Every Journey
          </Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-serif font-normal text-dark mt-6 text-[40px] sm:text-[52px] lg:text-[62px] leading-[1.02] tracking-[-0.02em]">
            Wherever life takes you,
            <br className="hidden sm:block" /> travel <span className="italic text-gold">better.</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-14 gap-x-8">
        {JOURNEYS.map((j, i) => {
          const Icon = j.icon;
          return (
            <Reveal
              key={j.title}
              delay={i * 0.09}
              data-testid={`journey-card-${i + 1}`}
              className="text-center flex flex-col items-center px-4"
            >
              <span className="flex items-center justify-center w-16 h-16 rounded-full border border-dark/12 mb-7">
                <Icon size={26} strokeWidth={1.5} className="text-gold" />
              </span>
              <h3 className="font-sans text-dark font-semibold text-[15px] mb-3">{j.title}</h3>
              <p className="font-sans text-dark/55 text-sm leading-relaxed max-w-[230px]">
                {j.body}
              </p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
